/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
import React, { useState, useEffect, useRef } from 'react'
import {
  Dropdown,
  Menu,
  Row,
  DatePicker,
  Button,
  notification,
  Radio,
  Tabs,
  Tooltip,
  Select,
} from 'antd'
import { useLazyQuery, useQuery } from 'react-apollo'
import { FaDownload } from 'react-icons/fa'
import moment from 'moment'
import { COLORS } from 'assets/styles/globalStyles'
import { PeakBlockWiseTable } from './peakBlockWiseTable'
import { PeakStimulusReport } from './peakStimulusWiseTable'
import { PeakBlockEqui } from './peakBlockEqui'
import { PEAK_BLOCKWISE, PEAK_EQUIVALENCE, SESSION_NAME, GET_STUDENT_SESSION_NAME } from './query'
import './form.scss'
import './table.scss'
import './style.scss'
import DropSection from './DropSection'

const { RangePicker } = DatePicker
const { TabPane } = Tabs
const { Option } = Select

const filterCardStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  padding: '5px 10px',
  margin: 0,
  height: 'fit-content',
  overflow: 'hidden',
  backgroundColor: COLORS.palleteLight,
}

const parentDiv = { display: 'flex', margin: '5px 30px 5px 0' }
const parentLabel = { fontSize: '15px', color: '#000', margin: 'auto 8px auto' }

const dateFormat = 'YYYY-MM-DD'

function PeakBlockReport({ selectedStudentId, studentName }) {
  const [dateRR, setDateRR] = useState([moment().subtract(11, 'd'), moment()])
  const [peakType, setpeakType] = useState('dir/gen')
  const studentId = localStorage.getItem('studentId')
  const [activeTab, setActiveTab] = useState('Block')
  const [activeEquiTab, setActiveEquiTab] = useState('Class')
  const [dateList, setDateList] = useState([])
  const [equiTrainTest, setEquiTrainTest] = useState('all')
  const [startDate, setStartDate] = useState(
    moment(Date.now())
      .subtract(11, 'days')
      .format('YYYY-MM-DD')
      .toString(),
  )
  const [endDate, setEndDate] = useState(
    moment(Date.now())
      .format('YYYY-MM-DD')
      .toString(),
  )
  const [
    getPeakBlockData,
    { data: peakBlockData, error: peakBlockError, loading: peakBlockLoading },
  ] = useLazyQuery(PEAK_BLOCKWISE)

  const [
    getPeakEquiData,
    { data: peakEqui, error: peakEquiError, loading: peakEquiLoading },
  ] = useLazyQuery(PEAK_EQUIVALENCE)

  const { data: sessionNames, error: sessionNamesError, loading: sessionNamesLoading } = useQuery(
    GET_STUDENT_SESSION_NAME,
    {
      variables: {
        studentId: JSON.parse(studentId),
      },
    },
  )

  const downloadCsvRef = useRef()
  const [peakBlockGen, setPeakBlockGen] = useState([])
  const [peakEquiData, setPeakEquiData] = useState([])
  const [sessionName, setSessionName] = useState('U2Vzc2lvbk5hbWVUeXBlOjE=')
  const DateChangeDropDown = date => {
    setStartDate(
      moment(date[0])
        .format('YYYY-MM-DD')
        .toString(),
    )
    setEndDate(
      moment(date[1])
        .format('YYYY-MM-DD')
        .toString(),
    )
  }
  useEffect(() => {
    if (dateRR[0] && dateRR[1]) {
      let start = dateRR[1]
      let end = dateRR[0]
      if (dateRR[0].format(dateFormat) < dateRR[1].format(dateFormat)) {
        start = dateRR[0]
        end = dateRR[1]
      }

      getPeakBlockData({
        variables: {
          start: start.format(dateFormat),
          end: end.format(dateFormat),
          student: studentId,
          sessionName,
        },
      })

      getPeakEquiData({
        variables: {
          start: start.format(dateFormat),
          end: end.format(dateFormat),
          student: studentId,
          sessionName,
          equivalence: true,
        },
      })

      const days = []
      let day = start
      while (day <= end) {
        days.push(day.toDate())
        day = day.clone().add(1, 'd')
      }

      const daysList = []
      days.forEach(dateStr => {
        daysList.push({
          monthYear: moment(dateStr)
            .format('MMM')
            .concat(moment(dateStr).format('YYYY')),
          date: moment(dateStr).format('YYYY-MM-DD'),
          month: moment(dateStr).format('MMM'),
          dayDate: moment(dateStr).format('DD'),
          day: moment(dateStr).format('ddd'),
          year: moment(dateStr).format('YYYY'),
        })
      })

      setDateList(daysList)
    }
  }, [dateRR, studentId, sessionName])

  useEffect(() => {
    if (peakBlockError) {
      console.error(peakBlockError)
    }
    if (sessionNamesError) {
      console.error(sessionNamesError)
    }
    if (peakEquiError) {
      console.error(peakEquiError)
    }
  }, [peakBlockError, sessionNamesError, peakEquiError])

  useEffect(() => {
    if (peakBlockData) {
      const tempBlockId = []
      const tempData = []
      let tempPeakBlockGen = []

      peakBlockData.peakBlockWiseReport.forEach(item => {
        tempData.push({
          date: item.date,
          blocks: item.blocks,
          target: item.target?.targetAllcatedDetails.targetName,
          peakType: item.target?.peakType,
        })
      })

      tempPeakBlockGen = tempData.filter(item => item.peakType !== 'EQUIVALENCE')
      tempPeakBlockGen = tempPeakBlockGen.filter(item => {
        if (
          item.target === null ||
          item.target === undefined ||
          item.blocks === null ||
          item.blocks.length === 0
        ) {
          return false
        }

        const tempBlock = item.blocks[0].id
        for (let i = 0; i < tempBlockId.length; i += 1) {
          if (tempBlockId[i] === tempBlock) {
            return false
          }
        }

        tempBlockId.push(tempBlock)
        return true
      })

      setPeakBlockGen(tempPeakBlockGen)
    }
  }, [peakBlockData])

  useEffect(() => {
    if (peakEqui) {
      let tempData = []
      const tempClassId = []

      peakEqui.peakBlockWiseReport.forEach(item => {
        tempData.push({
          date: item.date,
          equBlocks: item.equBlocks,
          targetName: item.target?.targetAllcatedDetails.targetName,
          targetId: item.target?.targetAllcatedDetails.id,
          peakType: item.target?.peakType,
        })
      })

      tempData = tempData.filter(item => {
        if (item.targetName === undefined || item.targetName === null || item.equBlocks === null) {
          return false
        }

        if (item.equBlocks.length === 0) {
          return true
        }
        for (let i = 0; i < tempClassId.length; i += 1) {
          if (item.equBlocks[0].id === tempClassId[i]) {
            return false
          }
        }

        tempClassId.push(item.equBlocks[0].id)
        return true
      })

      if (equiTrainTest === 'TRAIN' || equiTrainTest === 'TEST') {
        for (let i = 0; i < tempData.length; i += 1) {
          tempData[i].equBlocks = tempData[i].equBlocks.filter(item => {
            return item.recType === equiTrainTest
          })
        }
      }

      setPeakEquiData(tempData)
    }
  }, [peakEqui, equiTrainTest])

  const disabledDate = current => {
    if (current.format(dateFormat) > moment().format(dateFormat)) {
      return true
    }
    if (!dateRR || dateRR.length === 0) {
      return false
    }
    return false
  }
  const onOpenChange = open => {
    if (open) {
      setDateRR([])
    }
  }

  const menu = (
    <Menu>
      <Menu.Item key="1">
        <Button
          onClick={() => {
            if (peakType === 'dir/gen') {
              downloadCsvRef.current?.exportToCSV(activeTab)
            } else {
              downloadCsvRef.current?.exportToCSV(activeEquiTab)
            }
          }}
          type="link"
          size="small"
        >
          CSV/Excel
        </Button>
      </Menu.Item>
    </Menu>
  )

  const peakEquitabbarExt = (
    <Radio.Group
      size="small"
      value={equiTrainTest}
      style={{ margin: 'auto 0' }}
      onChange={e => {
        setEquiTrainTest(e.target.value)
      }}
      buttonStyle="solid"
    >
      <Radio.Button value="all">All</Radio.Button>
      <Radio.Button value="TRAIN">TRAIN</Radio.Button>
      <Radio.Button value="TEST">TEST</Radio.Button>
    </Radio.Group>
  )

  return (
    <div>
      <Row>
        <div style={filterCardStyle}>
          <div style={parentDiv}>
            <DropSection dateChange={v => DateChangeDropDown(v)} />
          </div>
          <div style={parentDiv}>
            <Tooltip title="Select Date range">
              <RangePicker
                // defaultValue={dateRR}
                value={[moment(startDate, 'YYYY-MM-DD'), moment(endDate, 'YYYY-MM-DD')]}
                defaultValue={[moment(startDate, 'YYYY-MM-DD'), moment(endDate, 'YYYY-MM-DD')]}
                format={dateFormat}
                disabledDate={disabledDate}
                onCalendarChange={val => setDateRR(val)}
                onOpenChange={onOpenChange}
                style={{
                  maxWidth: '240px',
                }}
              />
            </Tooltip>
          </div>
          {/* <div style={parentDiv}>
            <Tooltip title="Report Type">
              <Radio.Group
                size="small"
                value={peakType}
                style={{ margin: 'auto 0' }}
                onChange={e => {
                  setpeakType(e.target.value)
                }}
                buttonStyle="solid"
              >
                <Radio.Button value="dir/gen">Coded</Radio.Button>
                <Radio.Button value="equi">Relational</Radio.Button>
              </Radio.Group>
            </Tooltip>
          </div> */}
          <div style={parentDiv}>
            <Tooltip title="Session">
              <Select
                style={{ width: 220, borderRadius: 4 }}
                value={!sessionNamesLoading ? sessionName : 'Morning'}
                disabled={peakBlockLoading}
                onChange={v => setSessionName(v)}
                placeholder="ALL"
              >
                <Option key="all" value="">
                  All
                </Option>
                {sessionNames &&
                  sessionNames.getActiveSessionNames.map(({ id, name }) => (
                    <Option key={id} value={id}>
                      {name}
                    </Option>
                  ))}
              </Select>
            </Tooltip>
          </div>
          {/* <div style={parentDiv}>
            <Tooltip title="Sessions">
              <Radio.Group
                size="small"
                style={{ margin: 'auto 0' }}
                value={sessionName}
                onChange={e => setSessionName(e.target.value)}
                buttonStyle="solid"
              >
                <Radio.Button value="">All</Radio.Button>
                <Radio.Button value="U2Vzc2lvbk5hbWVUeXBlOjE=">Mor</Radio.Button>
                <Radio.Button value="U2Vzc2lvbk5hbWVUeXBlOjI=">After</Radio.Button>
                <Radio.Button value="U2Vzc2lvbk5hbWVUeXBlOjM=">Eve</Radio.Button>
                <Radio.Button value="U2Vzc2lvbk5hbWVUeXBlOjQ=">Def</Radio.Button>
              </Radio.Group>
            </Tooltip>
          </div> */}

          <div style={{ ...parentDiv, marginRight: 0 }}>
            <span style={parentLabel}>Block</span>
            <div
              style={{
                background: COLORS.target,
                borderRadius: 10,
                width: '20px',
                margin: 'auto 0',
                marginRight: '10px',
                height: 20,
              }}
            />
            <span style={parentLabel}>Stimulus</span>
            <div
              style={{
                background: COLORS.stimulus,
                borderRadius: 10,
                width: '20px',
                margin: 'auto 0',
                marginRight: '10px',
                height: 20,
              }}
            />
            <span style={parentLabel}>Class</span>
            <div
              style={{
                background: COLORS.class,
                borderRadius: 10,
                width: '20px',
                margin: 'auto 0',
                height: 20,
              }}
            />
          </div>
          <div style={{ marginLeft: 'auto' }}>
            <Dropdown overlay={menu} trigger={['click']}>
              <Button style={{ padding: '0 8px' }} type="link" size="large">
                <FaDownload fontSize={22} />
              </Button>
            </Dropdown>
          </div>
        </div>
      </Row>
      {peakType === 'dir/gen' ? (
        <Tabs
          style={{ marginTop: 10, marginLeft: 10 }}
          defaultActiveKey={activeTab}
          type="card"
          className="peak-report"
          onChange={setActiveTab}
        >
          <TabPane tab="Block" key="Block">
            <PeakBlockWiseTable
              dates={dateList}
              peakBlockData={peakBlockGen}
              peakBlockLoading={peakBlockLoading}
              ref={downloadCsvRef}
              studentName={studentName}
            />
          </TabPane>

          <TabPane tab="Stimulus" key="Stimulus/dir">
            <PeakStimulusReport
              dates={dateList}
              peakBlockData={peakBlockGen}
              peakBlockLoading={peakBlockLoading}
              ref={downloadCsvRef}
              studentName={studentName}
            />
          </TabPane>
        </Tabs>
      ) : (
        <Tabs
          style={{ marginTop: 10, marginLeft: 10 }}
          defaultActiveKey={activeEquiTab}
          type="card"
          className="peak-report"
          tabBarExtraContent={peakEquitabbarExt}
          onChange={setActiveEquiTab}
        >
          <TabPane tab="Class" key="Class">
            <PeakBlockEqui
              dates={dateList}
              peakEquiData={peakEquiData}
              peakEquiLoading={peakEquiLoading}
              expandType="Class"
              ref={downloadCsvRef}
              studentName={studentName}
            />
          </TabPane>

          <TabPane tab="Stimulus" key="Stimulus">
            <PeakBlockEqui
              dates={dateList}
              peakEquiData={peakEquiData}
              peakEquiLoading={peakEquiLoading}
              expandType="Stimulus"
              studentName={studentName}
              ref={downloadCsvRef}
            />
          </TabPane>
        </Tabs>
      )}
    </div>
  )
}

export default PeakBlockReport
